import { Addition } from '@/features/vehicles/types';
import { RootState } from '@/core/redux';

export const getVehicleCategoryAdditions = (state: RootState): Addition[] | null =>
  state.vehicles.additions ?? null;
